import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class SetHasAttachment extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetHasAttachment';

    public constructor(public id: string, public hasAttachment: boolean, public isCurrent?: () => boolean) {
        super(SetHasAttachment.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SetHasAttachment): void => {
    if (action.isCurrent && !action.isCurrent()) throw new Error('Attachment operation is obsolete');
    const card = getCardById(action.id);

    if (card) {
        card.hasAttachment = action.hasAttachment;
    }
};

//@ts-ignore
registerReducer(SetHasAttachment.ACTION_TYPE, reducer);
